export default function getComparableSaleResearchState(
  {get}: any,
  {housingCorporationId}: {housingCorporationId: number},
): Promise<any> {
  return get(`/comparable-sale-data`, {housingCorporationId}, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/comparableSaleResearchState/getComparableSaleResearchState.tsx